import CameraIcon from './CameraIcons';

export default function CameraControls({ status, onCapture, onSwitchCamera, onSelectGallery }) {
  return <div className="plate-camera__controls">
    <button type="button" className="plate-camera__tool" onClick={onSwitchCamera} aria-label="تعویض دوربین">
      <CameraIcon name="switch" size={26} />
    </button>
    <button type="button" className="plate-camera__shutter" onClick={onCapture} disabled={status !== 'ready'} aria-label="گرفتن عکس"><span /></button>
    <button type="button" className="plate-camera__tool" onClick={onSelectGallery} aria-label="انتخاب عکس از گالری">
      <CameraIcon name="gallery" size={26} />
    </button>
  </div>;
}
